import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import React, { FunctionComponent } from 'react';
import Button from '../buttons/Button';
import { Hr } from '../layout';
import { SubHeading, Text, TextLink } from '../typography';
import Container from './SearchTips.style';

interface Props {
  searchResult: PropertySearchResult;
  onSaveSearchClick: () => void;
}

const SearchTips: FunctionComponent<Props> = (props) => {
  const isBeyondLastPage =
    props.searchResult.page + 1 > props.searchResult.totalPages && props.searchResult.totalPages > 0;

  if (isBeyondLastPage) {
    const firstPage = props.searchResult.url.replace(/page-\d+/, '');
    const lastPage = `${firstPage}page-${props.searchResult.totalPages}`;

    return (
      <Container>
        <SubHeading>You have gone past the last page of the results for this search</SubHeading>

        <Text mt={30}>
          Go back to <TextLink href={lastPage}>the last page</TextLink> or{' '}
          <TextLink href={firstPage}>the first page</TextLink> of the results.
        </Text>
      </Container>
    );
  }

  return (
    <Container>
      <SubHeading>Tips for better search results</SubHeading>

      <Text mt={10}>Double check your spelling</Text>

      <Text mt={10}>Enter an area, street address or postcode e.g. Belfast, Antrim Road, BT9</Text>

      <Text mt={10}>Use the predictive feature to help you find a specific property</Text>

      <Text mt={10}>Be the first to know about properties in this area by saving your search.</Text>

      {props.searchResult.savable && (
        <>
          <Hr mt={30} />

          <SubHeading mt={20}>Save this search</SubHeading>

          <Text mt={10}>
            Did you know? You can save &quot;{props.searchResult.description.stem}&quot; as a search and we&apos;ll
            email you any matching properties as soon as they are added.
          </Text>

          <Button
            containerStyle={{ maxWidth: 300, marginTop: 30 }}
            onClick={props.onSaveSearchClick}
            testID="tipsSaveThisSearch"
            icon={faBell}
          >
            {props.searchResult.savedSearch ? 'Edit Saved' : 'Save this'} Search
          </Button>
        </>
      )}
    </Container>
  );
};

export default SearchTips;
